<style scoped lang="scss">
@import "../../style/color";

.footer {
  &-help,
  .footer-introduction-area,
  .footer-record-discription {
    @include content;
  }

  &-introduction {
    background: $c_000;
    height: 167px;

    .footer-introduction-ul {
      padding-top: 28px;
      width: 100%;

      .icon {
        font-size: $font-lg;
        text-align: center;
        width: 25%;

        .img {
          width: 75px;
          height: 75px;
          margin: auto;
          cursor: pointer;
        }

        .text {
          margin-top: 20px;
          color: $c_fff;
          font-size: $font_md;
          font-family: "EperFontLight";
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  &-help {
    margin-top: 31px;
    font-weight: bold;
    font-size: $font-lg;
    color: $c_000;
    .text:first-child {
      padding-left: 0;
    }

    .text:last-child {
      padding-right: 0;
    }

    .text {
      padding: 0 12px;
      // float: left;
      display: inline-block;
      cursor: pointer;
      font-family: "EperFontBold";
      font-size: $font_md;
      &:hover {
        text-decoration: underline;
      }
    }
    .lang {
      padding: 0 5px;
      // float: left;
      display: inline-block;
      cursor: pointer;
      font-family: "EperFontBold";
      font-size: 14px;
      &:hover {
        text-decoration: underline;
      }
    }
    .foot-icon {
      width: 247px;
      margin: auto;
      height: 53px;
      margin-top: 28px;
      text-align: center;

      .img:nth-child(2) {
        padding: 0;
        margin: 0 36px;
      }

      .img {
        width: 53px;
        height: 53px;
      }
    }
  }

  .footer-record {
    margin-top: 28px;
    font-size: 13px;
    border-top: 1px solid $c_f3f;
    line-height: 23px;
    a {
      color: #515a6e !important;
      &:hover {
        color: black;
        text-decoration: underline;
      }
    }
    &-discription {
      margin: 7px auto 15px auto;
      text-align: center;
    }

    .telephone {
      text-align: center;
    }
  }
  .footer-record.shopcart {
    padding-bottom: 58px;
    box-sizing: border-box;
    text-align: center;
  }
}
</style>

<template>
  <div class="footer clearfix">
    <div class="footer-introduction">
      <div class="footer-introduction-area">
        <ul class="footer-introduction-ul ovh">
          <li class="icon fl">
            <img
              src="../../assets/icon/footer/font-icon-1.png"
              alt=""
              class="img block"
              @click="toAus(1, 47)"
            />
            <span class="block text" @click="toAus(1, 47)">{{
              $t("foot.quality")
            }}</span>
          </li>
          <li class="icon fl">
            <img
              src="../../assets/icon/footer/font-icon-2.png"
              alt=""
              class="img block"
              @click="toAus(0, 42)"
            />
            <span class="block text" @click="toAus(0, 42)">{{
              $t("foot.selection")
            }}</span>
          </li>
          <li class="icon fl">
            <img
              src="../../assets/icon/footer/font-icon-3.png"
              alt=""
              class="img block"
              @click="toAus(3, 56)"
            />
            <span class="block text" @click="toAus(3, 56)">{{
              $t("foot.shopping")
            }}</span>
          </li>
          <li class="icon fl">
            <img
              src="../../assets/icon/footer/font-icon-4.png"
              alt=""
              class="img block"
              @click="toAus(2, 105)"
            />
            <span class="block text" @click="toAus(2, 105)">{{
              $t("foot.recycle")
            }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-help">
      <div class="ovh" style="text-align: center">
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(0, 42)"
        >
          {{ $t("foot.aboutUs") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(0, 42)"
        >
          {{ $t("foot.withUs") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(1, 47)"
        >
          {{ $t("foot.safety") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(5, 61)"
        >
          {{ $t("foot.delivery") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(4, 117)"
        >
          {{ $t("foot.guide") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(6, 65)"
        >
          {{ $t("foot.howPay") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(7, 98)"
        >
          {{ $t("foot.question") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(8, 103)"
        >
          {{ $t("foot.contanct") }}
        </span>
        <span
          :class="[{ text: lang != 3 }, { lang: lang == 3 }]"
          @click="toAus(7, 102)"
        >
          {{ $t("foot.private") }}
        </span>
      </div>
      <div class="foot-icon">
        <a href="http://www.facebook.com/epermarket"
          ><img
            class="img inlineBlock"
            src="../../assets/icon/footer/facebook.png"
            alt=""
        /></a>
        <a href="http://www.instagram.com/epermarket"
          ><img
            class="img inlineBlock"
            src="../../assets/icon/footer/instagram.png"
            alt=""
        /></a>
        <a href="https://www.linkedin.com/company/epermarket/"
          ><img
            class="img inlineBlock"
            src="../../assets/icon/footer/linkedin.png"
            alt=""
        /></a>
      </div>
    </div>
    <div :class="['footer-record', { shopcart: isShopCart }]">
      <div class="footer-record-discription">
        <!-- 沪ICP备12004682号-1 -->
        <span
          >Copyright 2011-2024 epermarket.com 上海赢盘实业有限公司 版权所有
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >沪ICP备12004682号</a
          ></span
        >
        <a
          href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020180122095918000002332403-SAIC_SHOW_310000-20190325150333729275&signData=MEUCIQCo4w/W5Inp42UdU935Sua9C+dhp/Ceq8aX20kmo1sHzgIgFakTvMp60w/Nf3EXy/8PepNAG4rVjgoN38oelDKVxGA="
          target="_blank"
          title="上海工商"
          ><img src="../../assets/icon/footer/ba1961.png" alt="上海工商"
        /></a>
        <img src="../../assets/icon/footer/ba1962.png" alt="备案" />
        <span class="bei"
          ><a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011802001973"
            target="_blank"
            >沪公网安备 31011802001973号</a
          ></span
        >
        <span class="block telephone">400 776 0776(08:00-20:00)</span>
      </div>
    </div>
  </div>
</template>

<script>
import filter from "../../plugins/filters";
export default {
  name: "Footer",
  props: {
    isShopCart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lang: filter.readData("lang"),
    };
  },
  // about?isShowMenu=4&NotifyId=61
  methods: {
    toAus(i, NotifyId) {
      this.$router.replace({
        path: "/about",
        query: {
          isShowMenu: i,
          NotifyId,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/Footer.vue